import React, { useEffect } from "react";

export default function GlobalSelectWrapper() {
useEffect(() => {
    const enhanceSelects = () => {
      document.querySelectorAll("select").forEach((nativeSelect) => {
        if (!nativeSelect.dataset.enhanced) {
          nativeSelect.dataset.enhanced = "true";

          // ✅ Force custom style directly on select
          nativeSelect.style.backgroundColor = "white";
          nativeSelect.style.color = "black";
          nativeSelect.style.border = "1px solid #ccc";
          nativeSelect.style.padding = "6px";
          nativeSelect.style.borderRadius = "6px";
          nativeSelect.style.cursor = "pointer";

          // ✅ Force style on all options
          Array.from(nativeSelect.options).forEach((opt) => {
            opt.style.backgroundColor = "white";
            opt.style.color = "black";
          });

          // ✅ Add hover effect using JS (works even if CSS doesn't)
          nativeSelect.addEventListener("mouseenter", () => {
            nativeSelect.style.backgroundColor = "#f0f0f0";
          });
          nativeSelect.addEventListener("mouseleave", () => {
            nativeSelect.style.backgroundColor = "white";
          });
        }
      });
    };

    enhanceSelects();

    // ✅ Observe DOM for new <select> (dynamic content)
    const observer = new MutationObserver(() => enhanceSelects());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}
